var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.14094 17.63583c1.12396-.89687 3.16146-1.73854 4.83333-1.24166 2.82083 1.97812 5.59583 2.02708 8.72292-.01042 2.52812-.78333 6.62812 2.72708 7.29479 5.26667.0625.1427.05312.31458-.02292.45-5.23229 9.20208-19.55729 9.01146-23.89375-.03125-.06875-.14167-.06458-.31563.01042-.45521.8125-1.50833 1.79896-2.95313 3.0552-3.97813zm8.8826-16.12958c3.83646 0 6.95209 3.10104 6.95209 6.9198 0 3.80728-3.11563 6.90624-6.95209 6.90624-3.825 0-6.93958-3.09896-6.93958-6.90625 0-3.81875 3.11458-6.91979 6.93958-6.91979z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFilled);
export default __webpack_public_path__ + "static/media/avatar-filled.4b769f67.svg";
export { ForwardRef as ReactComponent };